'use strict';

var _module$exports;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var routes = require('./routes');

module.exports = (_module$exports = {}, _defineProperty(_module$exports, routes.communicationService, {
    getConfig: 'getConfig',
    patchConfig: 'patchConfig',
    shutdown: 'shutdown',
    getLogs: 'getLogs',
    proxyRequest: 'proxyRequest'
}), _defineProperty(_module$exports, routes.storageServer, {
    folderContents: 'folderContents',
    createFolder: 'createFolder',
    transferFiles: 'transferFiles',
    deleteFiles: 'deleteFiles',
    moveFiles: 'moveFiles',
    renameFiles: 'renameFiles',
    availability: 'availability',
    crossTrust: 'crossTrust',
    resourceControls: 'resourceControls',
    setConfig: 'setConfig',
    getLogs: 'getLogs'
}), _defineProperty(_module$exports, routes.jetServer, {
    createHotFolder: 'createHotFolder',
    deleteHotFolder: 'deleteHotFolder',
    startServerTransfer: 'startServerTransfer',
    startServerTransferTest: 'startServerTransferTest',
    stopServerTransfer: 'stopServerTransfer',
    startClientTransfer: 'startClientTransfer',
    startClientTransferTest: 'startClientTransferTest',
    stopClientTransfer: 'stopClientTransfer',
    getLogs: 'getLogs',
    storageServerDeleteCache: 'storageServerDeleteCache',
    deleteFiles: 'deleteFiles',
    startRelay: 'startRelay',
    stopRelay: 'stopRelay'
}), _defineProperty(_module$exports, routes.flight, {
    getLogs: 'getLogs'
}), _defineProperty(_module$exports, routes.objectStorage, {
    s3cApiRequest: 's3cApiRequest',
    s3cTransfersRequest: 's3cTransferRequest'
}), _defineProperty(_module$exports, routes.cloudConfig, {
    put: 'putCloudConfig'
}), _defineProperty(_module$exports, routes.mediaEngine, {
    managementRequest: 'managementRequest',
    extractionRequest: 'extractionRequest',
    getLogs: 'getLogs'
}), _module$exports);